import { render } from "./dtl_page.vue?vue&type=template&id=0b4fc106&scoped=true"
import script from "./dtl_page.vue?vue&type=script&lang=js"
export * from "./dtl_page.vue?vue&type=script&lang=js"

import "./dtl_page.vue?vue&type=style&index=0&id=0b4fc106&scoped=true&lang=css"
import "./dtl_page.vue?vue&type=style&index=1&id=0b4fc106&lang=css"

import exportComponent from "E:\\devops.aliyun\\liangting\\liangting_business_web\\seller.web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b4fc106"]])

export default __exports__